import React, { useEffect } from 'react';
import { MainTable } from '../../../Components/MainTable/MainTable';
import Add from './Add';
import Edit from './Edit';
import { useModels } from './ModelStore';

function Models() {
    let { models, columns, getModels, deleteModel, setEd } = useModels()
    useEffect(() => {
        getModels()
    }, [])
    return (
        <MainTable
            pageTitle='Modellar'
            pcolumns={columns}
            pdata={models}
            add={<Add />}
            edit={<Edit />}
            defkey={'id'}
            onDelete={(e, rec) => {
                deleteModel(rec.id)
            }}
            onEdit={(rec) => {
                setEd(rec)
            }}
            setEd={setEd}
        />
    );
}

export default Models;